export default "/images/ZdeněkMičola.jpg?3b7a98c9ac9dbf74267267eb878f11a1";